import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import TopSection from '../../LT/TopSection';
import './index.css';
import DataDetails from './DataDetails';
import ButtonComponent from '../../../components/common/button/Button';
import { fetchData } from '../../../redux/actions/Contracts';
import { saveContractsCall } from '../../../redux/actions/SaveContracts';
import { toast } from 'react-toastify';
import { Loader } from '../../../components/common/Loader';
import { deleteContracts } from '../../../redux/actions/DeleteContract';
import Modal from "../../../components/common/modal/Modal";
import { submitContract } from '../../../redux/actions/SubmitContract';
import { getFilterContractsEndpoint } from '../../../common/endpoints';
import { fetchContractFilterData } from '../../../redux/actions/Contracts/GetContractFilter';
import { setSelectedItem } from '../../../redux/actions/SupportTicket/selectionSlice';

const Contracts = () => {
  const dispatch = useDispatch();
  const [btnDisabled, setIsBtnDisabled] = useState(true);
  const [rowsData, setRowsData] = useState([]);
  const [pageSize, setPageSize] = useState(3500);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPageItems, setTotalPageItems] = useState(0);
  const [totalItemCurrentPage, setTotalItemCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [seqIds, setSeqIds] = useState([]);
  const [isDeleteBtnDisable, setIsDeleteBtnDisable] = useState(true);
  const [openValidationErrorPopup, setOpenValidationErrorPopup] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState('');
  const [selectedVendorNames, setSelectedVendorNames] = useState([]);
  const [selectedVendorNumbers, setSelectedVendorNumbers] = useState([]);
  const [selectedMaterialNumbers, setSelectedMaterialNumbers] = useState([]);
  const procurementDivisionType = useSelector(
    (state) => state?.userCardType?.procurementDivisionType
  );
  const contractsDataList = useSelector((state) => state?.getContractsData);
  const userEmail = localStorage.getItem("data");
  const userName = localStorage.getItem("userName");
  const plantId = localStorage.getItem("selectedCDPlantCode");
  const userRole = localStorage.getItem("CDRole");

  const cleanUsername = (name) => {
    return name.replace(/\s*\[C\]/, ""); // Removes "[C]" with optional leading space
  };

  const handleCellValueChange = async (params) => {
    if (rowsData.some(row => row.contractSeqId === params.data.contractSeqId)) {
      const updatedSelectedRows = rowsData.map(row =>
          row.contractSeqId === params.data.contractSeqId ? params.data : row
        );
      setRowsData(updatedSelectedRows);
    }
  };

  const handleIsTestMode = () => {
    submitSimulateApiCall();
  };

  const submitSimulateApiCall = async () => {
    setIsLoading(true);
      try {
        const submitContracts = await dispatch(submitContract({
          params: {
            isTestMode: true,
            userEmailList: userEmail,
            userName: cleanUsername(userName),
            plantId: localStorage.getItem("selectedCDPlantCode"),
          },
          data: rowsData,
        }));
        if (submitContracts.meta.requestStatus === 'fulfilled') {
          setIsLoading(false)
          toast.success(`Simulate ${submitContracts.payload}`, {
            autoClose: 3000,
          });
          dispatch(
            fetchData({
              dynamicEndpoint: `api/cd/contracts/${procurementDivisionType}`,
              params: {
                page: currentPage, // Use the current page
                size: pageSize, // Use the current page size
                plantId: localStorage.getItem("selectedCDPlantCode")
              },
            })
          );
          setIsBtnDisabled(true)
          setIsDeleteBtnDisable(true)
        } else {
          toast.error(`${submitContracts?.payload}`, {
            autoClose: 2000,
          });
          dispatch(
            fetchData({
              dynamicEndpoint: `api/cd/contracts/${procurementDivisionType}`,
              params: {
                page: currentPage, // Use the current page
                size: pageSize, // Use the current page size
                plantId: localStorage.getItem("selectedCDPlantCode")
              },
            })
          );
          setIsLoading(false)
          setIsBtnDisabled(true)
          setIsDeleteBtnDisable(true)
        }
      } catch (error) {
        console.error('API error:', error);
        toast.error(`Something went wrong, Please try later`, {
          autoClose: 2000,
        });
        setIsLoading(false)
        setIsBtnDisabled(true)
        setIsDeleteBtnDisable(true)
      }
  }

  const getMandatoryFieldsForRow = (row, plantId) => {
    let fields = [
      { field: 'pricingOrderPriceUnit', title: 'Order Price Unit' },
      { field: 'agreementDate', title: 'Agreement Date' },
      { field: 'companyCode', title: 'Company Code' },
      { field: 'purchaseOrganisation', title: 'Purchasing organization' },
      { field: 'purchaseGroup', title: 'Purchase Group' },
      { field: 'validityStartDate', title: 'Validity Start Date' },
      { field: 'validityEndDate', title: 'Validity End Date' },
      { field: 'paymentTerms', title: 'Terms of Payment' },
      { field: 'currency', title: 'Currency Key' },
      { field: 'headIncotermVersion', title: 'Incoterms Version' },
      { field: 'headIncoterms', title: 'Incoterms 1' },
      { field: 'headIncotermsLoc1', title: 'Incoterms Location 1' },
      { field: 'category', title: 'Category' },
      { field: 'itemMaterialNumber', title: 'Material Number' },
      { field: 'itemOrderPriceUnit', title: 'Order Price Unit' },
      { field: 'itemNetPrice', title: 'Net Price' },
      { field: 'itemPer', title: 'Per' },
      { field: 'itemPlant', title: 'Plant' },
      { field: 'itemStorageLocation', title: 'Storage Location' },
      { field: 'itemOrderAckRequirement', title: 'Order Ack Requirement' },
      { field: 'invoicingParty', title: 'Different Invoicing Party' },
      { field: 'itemIncotermVersion', title: 'Incoterms Version' },
      { field: 'itemIncoterms', title: 'Incoterms' },
      { field: 'itemIncotermsLoc1', title: 'Incoterms Location 1' },
      { field: 'confControl', title: 'Confirmation Control Key' },
      // { field: 'shippingInstructions', title: 'Shipping Instructions' },
      { field: 'pricingPer', title: 'Per 1' },
      { field: 'conditionAmount', title: 'Condition Amount' },
    ];
    if (row.agreementType === 'WK') {
      fields = [...fields, { field: 'targetValue', title: 'Target value for Header Area/Dist' }];
    }
    if (row.agreementType === 'MK') {
      fields = [...fields, { field: 'itemTargetQuantity', title: 'Target Quantity' }];
    }
    if (!['5040', '0178', '0340', '0194', '0120'].includes(plantId)) {
      fields = [...fields, { field: 'taxCode', title: 'Tax Code' }];
    }
    if (row?.scaleQuantity !== null && row?.scaleQuantity !== '' && row?.scaleQuantity !== '-') {
      fields = [...fields, { field: 'scaleUOM', title: 'Condition Scale Unit of Measure' }];
    }
    return fields;
  };

  const handleContractSubmit = async () => {
    const emptyFieldsPerRow = rowsData.map(row => {
      const mandatoryFields = getMandatoryFieldsForRow(row, plantId);
      const emptyFields = mandatoryFields.filter(({ field }) => !row[field] || row[field] === "-");
      return { contractSerialNumber: row.contractSerialNumber, emptyFields };
    }).filter(row => row.emptyFields.length > 0);

    if (emptyFieldsPerRow.length > 0) {
      const seqIds = emptyFieldsPerRow.map(row => row.contractSerialNumber);
      const errorMessage = `Mandatory fields are empty for Contract Serial No: ${seqIds}. Please check the highlighted fields in red and try again!`
      setValidationErrorMessage(errorMessage);
      setOpenValidationErrorPopup(true);
      return;
    } else if (emptyFieldsPerRow?.length === 0) {
      submitApiCall();
    }
  }

  const submitApiCall = async () => {
    setIsLoading(true);
      try {
        const submitContracts = await dispatch(submitContract({
          params: {
            isTestMode: false,
            userEmailList: userEmail,
            userName: cleanUsername(userName),
            plantId: localStorage.getItem("selectedCDPlantCode"),
          },
          data: rowsData,
        }));
        if (submitContracts.meta.requestStatus === 'fulfilled') {
          setIsLoading(false)
          toast.success(submitContracts.payload, {
            autoClose: 3000,
          });
          dispatch(
            fetchData({
              dynamicEndpoint: `api/cd/contracts/${procurementDivisionType}`,
              params: {
                page: currentPage, // Use the current page
                size: pageSize, // Use the current page size
                plantId: localStorage.getItem("selectedCDPlantCode")
              },
            })
          );
          setIsBtnDisabled(true)
          setIsDeleteBtnDisable(true)
        } else {
          toast.error(`${submitContracts?.payload}`, {
            autoClose: 2000,
          });
          dispatch(
            fetchData({
              dynamicEndpoint: `api/cd/contracts/${procurementDivisionType}`,
              params: {
                page: currentPage, // Use the current page
                size: pageSize, // Use the current page size
                plantId: localStorage.getItem("selectedCDPlantCode")
              },
            })
          );
          setIsLoading(false)
          setIsBtnDisabled(true)
          setIsDeleteBtnDisable(true)
        }
      } catch (error) {
        console.error('API error:', error);
        toast.error(`Something went wrong, Please try later`, {
          autoClose: 2000,
        });
        setIsLoading(false)
        setIsBtnDisabled(true)
        setIsDeleteBtnDisable(true)
      }
  }
  

  // const onSelectionChanged = (params) => {
  //   const selectedCheckBoxCount = params.api.getSelectedNodes().length;
  //   const data = params.api.getSelectedRows();
  //   setRowsData(data);
  //   const ids = data?.map(item => item?.contractSeqId);
  //   setSeqIds(ids);
  //   selectedCheckBoxCount === 0 ? setIsDeleteBtnDisable(true) : setIsDeleteBtnDisable(false);
  //   selectedCheckBoxCount ? setIsBtnDisabled(false) : setIsBtnDisabled(true);
  // };

  const onSelectionChanged = (params) => {
    const displayedRows = [];
    params?.api?.forEachNodeAfterFilterAndSort((node) => {
      if (node.isSelected()) {
        displayedRows.push(node.data);
      }
    });

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    const rowsInCurrentPage = displayedRows.slice(startIndex, endIndex);

    const selectedRows = rowsInCurrentPage.filter((row) =>
      params.api.getSelectedNodes().some((node) => node.data === row)
    );

    setRowsData(selectedRows);
    dispatch(setSelectedItem(selectedRows));

    const ids = selectedRows?.map(item => item?.contractSeqId);
    setSeqIds(ids);
    selectedRows?.length === 0 ? setIsDeleteBtnDisable(true) : setIsDeleteBtnDisable(false);
    selectedRows?.length ? setIsBtnDisabled(false) : setIsBtnDisabled(true);
  }

  const rowSelection = useMemo(() => {
    return {
      mode: "multiRow",
      isRowSelectable: (rowNode) =>
        rowNode.data.status.toLowerCase() === "contract submitted successfully" ||
        userRole === "Viewer"
          ? false
          : true,
    };
  }, [userRole]);

  const getRowStyle = (params) => {
    const isRowAutoSubmitted = params?.data?.autoSubmitted;
    if (params.data.status.toLowerCase() === "contract submitted successfully") {
      return { backgroundColor: "#aaaaaa" };
    } 
    if (isRowAutoSubmitted === true) {
      return { backgroundColor: "#2244CC44" };
    }
    return null;
  }; 

  const saveContractsHandler = async () => {
    setIsLoading(true);
    try {
      const savedContract = await dispatch(saveContractsCall({
        data: rowsData,
        params: {
          userId: userEmail,
          userName: cleanUsername(userName),
          plantId: localStorage.getItem("selectedCDPlantCode")
        },
      }));
      if (savedContract.meta.requestStatus === 'fulfilled') {
        setIsLoading(false)
        toast.success("Contracts Modified Successfully", {
          autoClose: 2000,
        });
        setRowsData([]);
        dispatch(
          fetchData({
            dynamicEndpoint: `api/cd/contracts/${procurementDivisionType}`,
            params: {
              page: currentPage, // Use the current page
              size: pageSize, // Use the current page size
              plantId: localStorage.getItem("selectedCDPlantCode")
            },
          })
        );
        setIsBtnDisabled(true)
        setIsDeleteBtnDisable(true)
      } else {
        setIsLoading(false)
        toast.error(`Something went wrong - ${savedContract.error}`, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true)
        setIsDeleteBtnDisable(true)
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }
  
  useEffect(() => {
    setIsLoading(true);
    const fetchDataFromApi = async () => {
      try {
        const response = await dispatch(
          fetchData({
            dynamicEndpoint: `api/cd/contracts/${procurementDivisionType}`,
            params: {
              page: currentPage,
              size: pageSize,
              plantId: localStorage.getItem("selectedCDPlantCode") 
            },
          })
        );
        if (response.meta.requestStatus === "fulfilled") {
          setIsLoading(false);
          setTotalPages(response?.payload?.totalPages);
          setTotalPageItems(response?.payload?.totalNumberOfItems);
          setTotalItemCurrentPage(response?.payload?.totalItemsInPage);
        } else {
          setIsLoading(false);
          console.log(
            "Failed to fetch data:",
            response.payload.responseMessage
          );
        }
      } catch (error) {
        console.log("API error:", error);
      }
    };
    fetchDataFromApi();
  }, [dispatch, procurementDivisionType, currentPage, pageSize]);

  useEffect(() => {
    if (procurementDivisionType) {
      setCurrentPage(1);
    }
  }, [procurementDivisionType]);

    const onPageSizeChanged = (event) => {
      setPageSize(Number(event.target.value));
      setCurrentPage(1); // Reset to first page
    };
   
    const goToPage = (page) => {
      if (page >= 1 && page <= totalPages) {
        setCurrentPage(page);
      }
    };

    const deleteContractHandler = async () => {
      setIsLoading(true);
      try {
        const delContract = await dispatch(
          deleteContracts({
            data: {
              contractSeqIds: seqIds,
            },
            params: {
              userId: userEmail,
              userName: cleanUsername(userName),
              plantId: localStorage.getItem("selectedCDPlantCode")
            },
          })
        );
        if (delContract.meta.requestStatus === "fulfilled") {
          setIsLoading(false);
          toast.success(delContract?.payload?.message, {
            autoClose: 2000,
          });
          dispatch(
            fetchData({
              dynamicEndpoint: `api/cd/contracts/${procurementDivisionType}`,
              params: {
                page: currentPage,
                size: pageSize,
                plantId: localStorage.getItem("selectedCDPlantCode")
              },
            })
          );
          setIsBtnDisabled(true);
        } else {
          setIsLoading(false);
          toast.error(`Something went wrong - ${delContract.payload.errorMessage}`, {
            autoClose: 2000,
          });
        }
      } catch (error) {
        console.error("API error:", error);
      }
    };

  const handleSelectedItemsChange = (name, selectedItems) => {
    if (name === "vendorName") {
      setSelectedVendorNames(selectedItems);
    } else if (name === 'vendorNumber') {
      setSelectedVendorNumbers(selectedItems);
    } else if (name === 'materialNumber') {
      setSelectedMaterialNumbers(selectedItems)
    }
  }

  const handleSubmitFilter = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (selectedVendorNames.length > 0 || selectedVendorNumbers.length > 0 || selectedMaterialNumbers.length > 0) {
      const vendorNameItems = selectedVendorNames?.map(item => item.value.replace(/,/g, '%252C')).join(',');
      const vendorNumberItems = selectedVendorNumbers?.map(item => item.value).join(',');
      const materialNumberItems = selectedMaterialNumbers?.map(item => item.value).join(',');
      
    try {
      const contractFilterData = await dispatch(
        fetchContractFilterData({
          dynamicEndpoint: `${getFilterContractsEndpoint}/${procurementDivisionType}/filterContracts?plantId=${plantId}&filterBy=vendorNumber&values=${vendorNumberItems}&filterBy=itemMaterialNumber&values=${materialNumberItems}&filterBy=vendorName&values=${vendorNameItems}`,
        })
      );
      if (contractFilterData.meta.requestStatus === "fulfilled") {
        setIsLoading(false);
      } else {
        console.error(
          "contractFilter:",
          contractFilterData.error
        );
        toast.error(`Something went wrong - ${contractFilterData.error}`, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.log('API error:', error);
      setIsLoading(false);
    }
  } else if (selectedVendorNames.length === 0 && selectedVendorNumbers.length === 0 && selectedMaterialNumbers.length === 0) {
    fetchDataFromApi();
  }
}

  const fetchDataFromApi = async () => {
    try {
      const response = await dispatch(
        fetchData({
          dynamicEndpoint: `api/cd/contracts/${procurementDivisionType}`,
          params: {
            page: currentPage,
            size: pageSize,
            plantId: localStorage.getItem("selectedCDPlantCode") 
          },
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        setIsLoading(false);
        setTotalPages(response?.payload?.totalPages);
        setTotalPageItems(response?.payload?.totalNumberOfItems);
        setTotalItemCurrentPage(response?.payload?.totalItemsInPage);
      } else {
        setIsLoading(false);
        console.log(
          "Failed to fetch data:",
          response.payload.responseMessage
        );
      }
    } catch (error) {
      console.log("API error:", error);
    }
  };

  return (
    <>
      <TopSection
        labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "Contracts" },
        ]}
        hideHeader={true}
        headerName={"Contract Data Automation"}
      />
      <div className="priceMemo_main">
        <div className="priceMemo_subCls">
          <p>{procurementDivisionType} Contracts</p>
        </div>
        {isLoading ? (
          <Loader />
        ) : contractsDataList.loading === false && contractsDataList.error ? (
          <div style={{ textAlign: "center", fontWeight: "bold", color: 'red', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {`Something went wrong ${contractsDataList?.error?.responseMessage}`}
          </div>
        ) : (
          <div className="priceMemo_dataTable">
            <DataDetails
              // onRowSelected={onRowSelected}
              handleCellValueChange={handleCellValueChange}
              rowSelection={rowSelection}
              onPageSizeChanged={onPageSizeChanged}
              goToPage={goToPage}
              pageSize={pageSize}
              currentPage={currentPage}
              totalPages={totalPages}
              totalPageItems={totalPageItems}
              totalItemCurrentPage={totalItemCurrentPage}
              onSelectionChanged={onSelectionChanged}
              getRowStyle={getRowStyle}
              procurementDivisionType={procurementDivisionType}
              selectedVendorNames={selectedVendorNames}
              selectedVendorNumbers={selectedVendorNumbers}
              selectedMaterialNumbers={selectedMaterialNumbers}
              handleSelectedItemsChange={handleSelectedItemsChange}
              handleSubmitFilter={handleSubmitFilter}
              rowsData={rowsData}
              setRowsData={setRowsData}
              userRole={userRole}
              // handleClearFilter={handleClearFilter}
            />
            { userRole !== "Viewer" &&
            <div
              style={{
                marginTop: "50px",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "30px",
              }}
            >
              <div>
                <ButtonComponent
                  label="Simulate"
                  bgColor="#000"
                  color="#fff"
                  onClick={handleIsTestMode}
                  disabled={btnDisabled}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "250px",
                }}
              >
                <ButtonComponent
                  label="Delete"
                  bgColor="#fff"
                  color="#000"
                  disabled={isDeleteBtnDisable}
                  onClick={deleteContractHandler}
                />
                <ButtonComponent
                  label="Save"
                  bgColor="#fff"
                  color="#000"
                  disabled={btnDisabled}
                  onClick={saveContractsHandler}
                />
                <ButtonComponent
                  label="Submit"
                  bgColor="#000"
                  color="#fff"
                  onClick={handleContractSubmit}
                  disabled={btnDisabled}
                />
              </div>
            </div>
            }
          </div>
        )}
      </div>
      { openValidationErrorPopup &&
      <Modal
        open={openValidationErrorPopup}
        handleClose={() => setOpenValidationErrorPopup(false)}
        title="Validation Error"
        content={
          <div>
            <p>{validationErrorMessage}</p>
          </div>
        }
        action={
          <ButtonComponent
            maxWidth="170px"
            label="Close"
            bgColor="white"
            color="black"
            onClick={() => setOpenValidationErrorPopup(false)}
          />
        }
      />}
    </>
  );
}

export default Contracts